import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);

  const isRtl = language === 'ar';

  const toggleLanguage = () => setLanguage(language === 'en' ? 'ar' : 'en');
  const toggleSidebar = () => setSidebarCollapsed(!isSidebarCollapsed);

  return (
    <div
      dir={isRtl ? 'rtl' : 'ltr'}
      className="grid grid-cols-[15%_85%] h-screen"
    >
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        isRtl={isRtl}
      />
      <div />
      <div
        className={`flex flex-col w-full ${window.location.pathname === '/dashbaord' ? 'bg-[#F5F5F5] ' : ''}   `}
      >
        <Navbar toggleLanguage={toggleLanguage} language={language} />
        <main className={`p-0 overflow-auto  `}>{children}</main>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default Layout;

/**
 * screen width 1440
 *
 * avail = 1168
 *
 * 366 width , height 380
 *   same above          height 785
 *
 * sidebar 272px
 */
